import { HASH_REGEX } from "./consts";

export const isSha1Hash = (hash: string) =>
  HASH_REGEX.test(hash) && hash.length === 40;

export const isHash = (hash: string) =>
  HASH_REGEX.test(hash) && [32, 40, 64].includes(hash.length);
